(() => {
  if (window.gdLeadTrackingReady) return;
  window.gdLeadTrackingReady = true;
  const path = location.pathname;
  const key = 'gd-lead:' + path;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const measurementId = 'G-DM5ZXHZKRX';
  const preview = window.Shopify?.designMode === true || new URLSearchParams(location.search).has('preview_theme_id');
  let configured = false;
  const consentState = analytics => ({
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });
  const startAnalytics = () => {
    if (preview || !/^G-[A-Z0-9]+$/.test(measurementId)) return false;
    const analytics = allowed();
    window['ga-disable-' + measurementId] = !analytics;
    if (!analytics) {
      if (configured) window.gtag('consent', 'update', consentState(false));
      return false;
    }
    if (!configured) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', consentState(false));
      window.gtag('consent', 'update', consentState(true));
      window.gtag('js', new Date());
      window.gtag('config', measurementId, {
        send_page_view: false,
        page_location: location.origin + path,
        page_referrer: document.referrer.split('?')[0].split('#')[0],
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });
      configured = true;
      window.gtag('event', 'page_view', {
        send_to: measurementId,
        page_location: location.origin + path,
        page_referrer: document.referrer.split('?')[0].split('#')[0],
        page_title: document.title
      });
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
        document.head.appendChild(script);
      }
    } else {
      window.gtag('consent', 'update', consentState(true));
    }
    return true;
  };
  const category = () => path.startsWith('/products/') ? 'product' : path.startsWith('/blogs/technical-guides/') ? 'technical_guide' : path.startsWith('/pages/') ? 'page' : 'other';
  const emit = (name, parameters = {}) => {
    if (!startAnalytics()) return false;
    const clean = {send_to: measurementId, page_location: location.origin + path, page_path: path, source_type: category(), ...parameters};
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, clean);
      return true;
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({event: name, ...clean});
      return true;
    }
    return false;
  };
  const readPending = () => {
    try {
      const value = sessionStorage.getItem(key);
      const pending = value ? JSON.parse(value) : null;
      if (!pending || !Number.isFinite(pending.at) || Date.now() - pending.at > 1800000 || pending.at > Date.now()) {
        sessionStorage.removeItem(key);
        return null;
      }
      return pending;
    } catch { return null; }
  };
  const checkSuccess = () => {
    if (!document.querySelector('[data-gd-lead-success]')) return;
    const pending = readPending();
    if (!pending) return;
    if (emit('generate_lead', {lead_type: pending.source === 'technical_support_popup' ? 'technical_support' : path.includes('request-sample') ? 'sample' : 'project', form_location: pending.source === 'technical_support_popup' ? 'popup' : 'page'})) {
      try { sessionStorage.removeItem(key); } catch {}
    }
  };
  document.addEventListener('click', event => {
    const a = event.target.closest?.('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.startsWith('mailto:')) { emit('email_click'); return; }
    if (href.startsWith('tel:')) { emit('phone_click'); return; }
    let u;
    try { u = new URL(href, location.href); } catch { return; }
    if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(u.hostname)) {
      emit('whatsapp_click');
      return;
    }
    if (a.hasAttribute('data-gd-download') || /\.pdf$/i.test(u.pathname)) {
      emit('datasheet_download', {document_path: u.pathname});
      return;
    }
    if (u.origin !== location.origin) return;
    if (/^\/(?:pages|products)\/(?:12v|24v)-(?:100|200|300|400)ft-installer-kit$/.test(u.pathname)) {
      emit('installer_kit_click', {kit_path: u.pathname});
    } else if (u.pathname === '/pages/request-sample') {
      emit('sample_request_click');
    } else if (u.pathname === '/pages/discuss-your-project') {
      emit('discuss_project_click');
    }
  });
  document.querySelectorAll('form[action*="contact"]').forEach(form => {
    form.addEventListener('submit', event => {
      if (event.defaultPrevented || !form.checkValidity() || !allowed()) return;
      try { sessionStorage.setItem(key, JSON.stringify({at: Date.now(), source: form.id === 'GDSupportForm' ? 'technical_support_popup' : 'page'})); } catch {}
    });
  });
  const consentChanged = () => { startAnalytics(); checkSuccess(); };
  document.addEventListener('visitorConsentCollected', consentChanged);
  consentChanged();
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) consentChanged();
    });
  }
})();
